export const filterProductsByCategory = (products, category) => {
  if (category === "All Categories") {
    return products;
  }
  return products.filter((product) => product.product_categories.includes(category));
};

export const filterProductsByTime = (products) => {
  const currentTime = new Date();
  const isTimeBased = (product) => product.available_start_time && product.available_end_time;

  return products.filter((product) =>
    isTimeBased(product) ? currentTime < new Date(product.available_end_time) : true
  );
};

export const hasVariantOnDiscount = (product) => {
  if (!product) return false;
  return product.variants.some((variant) => variant.original_price !== null);
};

export const normalizeTime = (currentTime, minTime, maxTime) => {
  return ((currentTime - minTime) / (maxTime - minTime)) * 100;
};

export const formatTimePercentage = (time) => {
  // to make sure that time percentage can be seen on pie clearly
  if (time <= 0) {
    return 0;
  }

  if (time <= 10) {
    return 10;
  }

  if (time >= 90) {
    if (time >= 100) {
      return 100;
    }

    return 90;
  }

  return time;
};
